import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  badgeArea: {
    lineHeight: '24px',
    verticalAlign: 'middle',
    position: 'absolute',
    left: '0',
    top: '48px',
    padding: theme.spacing(2, 0, 0, 4),
    textAlign: 'left',
    [theme.breakpoints.up('sm')]: {
      top: '72px',
    },
    [theme.breakpoints.up('md')]: {
      top: '96px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0',
      textAlign: 'center',
    },
  },
  wrapper: {
    '& > *': {
      margin: theme.spacing(2, 0),
    },
  },
  error: {
    display: 'block',
    marginTop: theme.spacing(-1),
    color: 'rgb(244, 67, 54)',
  },
  statusIcon: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(-1),
    verticalAlign: 'middle',
  },
  verified: {
    color: 'rgb(0, 165, 0)',
    verticalAlign: 'middle',
    animation: `${keyframes`
      from {
        opacity: 0;
        transform: translateY(-24px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    `} 0.5s ease-out 0.55s`,
    animationFillMode: 'backwards',
  },
}))
